<template>
  <div>
    <el-dialog :visible.sync="filesShow" :title="$t('statusGrid.files')" center>
      <files-select
        :queueId="queueId"
        :style="{ width: '100%' }"
      ></files-select>
    </el-dialog>
    <el-dialog
      :visible.sync="zombiesOptionShow"
      :title="$t('statusGrid.zombies.clearZombies')"
      @close="clearZombiesClose"
    >
      <el-radio v-model="clearWithHttp" label="no">{{
        $t("statusGrid.zombies.withoutHttp")
      }}</el-radio>
      <el-radio
        v-model="clearWithHttp"
        label="yes"
        :disabled="getUser && +getUser.roleid > 1"
        >{{ $t("statusGrid.zombies.withHttp") }}</el-radio
      >

      <span slot="footer" class="dialog-footer">
        <el-button @click="clearZombiesClose">{{
          $t("statusGrid.cancel")
        }}</el-button>
        <el-button type="primary" @click="clearZombies">{{
          $t("statusGrid.continue")
        }}</el-button>
      </span>
    </el-dialog>
    <div class="buttons-grid between">
      <!-- <el-button class="el-icon-">Скачать</el-button> -->
      <div style="display: flex">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.download')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="downloadClick"
              class="el-icon-download"
              type="primary"
              :disabled="
                buttonDisabled ||
                gridType === 'running' ||
                selectedArray.length > 1
              "
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.watchLog')"
          placement="bottom-start"
        >
          <!-- <el-button @click="viewClick" class="el-icon-view" :disabled="buttonDisabled"></el-button> -->
          <span>
            <result-log-button
              :disabled="
                buttonDisabled ||
                gridType === 'running' ||
                selectedArray.length > 1
              "
              :queueId="queueId"
              iconButton
            ></result-log-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.delete')"
          v-if="gridType !== 'deleted'"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="deleteClick"
              class="el-icon-delete"
              type="danger"
              :disabled="buttonDisabled"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.restore')"
          placement="bottom-start"
          v-if="gridType === 'deleted'"
        >
          <span>
            <el-button
              @click="deleteClick"
              class="el-icon-back"
              type="primary"
              :disabled="buttonDisabled"
            ></el-button>
          </span>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.deleteSelected')"
          placement="bottom-start"
          v-if="gridType === 'deleted' && getUser"
        >
          <span>
            <el-button
              @click="deleteAllClick('selected')"
              class="el-icon-delete"
              type="danger"
              :disabled="buttonDisabled"
            ></el-button>
          </span>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.zombies.clearZombies')"
          v-if="gridType === 'running'"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="clearZombiesClick"
              class="el-icon-close"
              type="primary"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          v-if="gridType === 'deleted' && getUser && +getUser.roleid <= 1"
          effect="light"
          :content="$t('statusGrid.emptyTrash')"
          placement="bottom-start"
        >
          <span>
            <el-button @click="deleteAllClick('all')" type="danger">{{
              $t("statusGrid.emptyTrash")
            }}</el-button>
          </span>
        </el-tooltip>
        <!-- <el-button @click="delTasksByDaysClicked">DelTasksBydays</el-button> -->
        <el-dropdown trigger="click">
          <el-button type="plain" size="small" class="view-dropdown">
            {{ $t("statusGrid.view") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="optimalViewBtn">{{
              $t("statusGrid.compact")
            }}</el-dropdown-item>
            <el-dropdown-item @click.native="fullViewBtn">{{
              $t("statusGrid.full")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('statusGrid.refresh')"
          placement="bottom-start"
        >
          <span class="refresh-button">
            <el-button
              @click="refreshClick"
              class="el-icon-refresh-right"
              size="mini"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
      <div
        class="days-total"
        v-if="gridType === 'finished' && getUser && +getUser.roleid <= 1"
        @keyup.enter="deleteDaysClicked"
      >
        <span>{{
          $t("statusGrid.leaveInLast") + " __ " + $t("statusGrid.days")
        }}</span>
        <el-input-number
          size="mini"
          v-model="numOfDaysToDelete"
        ></el-input-number>
        <el-button class="button-confirm" size="mini" @click="deleteDaysClicked"
          >OK</el-button
        >
      </div>
    </div>

    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-full">
        <ag-grid-vue
          style="
            width: 100%;
            height: 100%;
            font-family: 'Open Sans', sans-serif;
          "
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="gridData"
          :defaultColDef="defaultColDef"
          :rowClassRules="rowClassRules"
          rowSelection="multiple"
          :localeText="agGridlocaleText"
          rowDeselection
          suppressCellSelection
          @grid-ready="onGridReady"
          @first-data-rendered="onGridFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @column-resized="onColumnResized"
          @rowSelected="onRowSelected"
          @row-data-changed="onGridDataChanged"
        ></ag-grid-vue>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import FilesSelect from "./FilesSelect";
import ResultLogButton from "./ResultLogButton";
import parseZombiesMixin from "./parseZombiesMixin";
export default {
  data() {
    return {
      columnDefs: null,
      defaultColDef: null,
      agGridlocaleText: null,
      rowClassRules: null,

      gridApi: null,
      columnApi: null,
      settings: null,
      currentRowSelected: null,
      selectedArray: null,
      buttonDisabled: true,
      resultLog: null,
      resultShow: false,
      filesShow: false,
      queueId: null,
      numOfDaysToDelete: 15,
      firstRenderFlag: false,

      clearWithHttp: "no",
      zombiesOptionShow: false,
    };
  },
  methods: {
    downloadClick() {
      this.$store.commit("setLoading", true);
      this.$store.dispatch("getQueueTaskById", this.queueId).then(() => {
        this.$store.commit("setLoading", false);
        this.filesShow = true;
      });
    },
    clearZombiesClick() {
      this.zombiesOptionShow = true;
    },
    clearZombiesClose() {
      this.clearWithHttp = "no";
      this.zombiesOptionShow = false;
    },
    clearZombies() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("clearZombies", this.clearWithHttp)
        .then(({ clean }) => {
          this.parseZombies(clean, true);
          this.$store.commit("setLoading", false);
          this.zombiesOptionShow = false;
          this.clearWithHttp = "no";
        })
        .catch((err) => {
          this.$store.commit("setLoading", false);
          this.zombiesOptionShow = false;
          this.clearWithHttp = "no";
          console.error(err);
        });
    },
    deleteDaysClicked() {
      let statusTask;
      let taskName = "";
      if (this.gridType === "finished") {
        statusTask = 2;
        taskName = this.$t("statusGrid.completed");
      } else if (this.gridType === "running") {
        taskName = this.$t("statusGrid.stated");
        statusTask = 1;
      } else {
        return;
      }
      if (this.numOfDaysToDelete > 0) {
        this.$confirm(
          `${this.$t(
            "statusGrid.thisActionRemoveAllToTrash"
          )} ${taskName} ${this.$t("statusGrid.tasksAfter")} ${
            this.numOfDaysToDelete
          } ${this.$t("statusGrid.daysFromToday")}`,
          this.$t("statusGrid.attention"),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t("statusGrid.cancellation"),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);
            return this.$store.dispatch("delTasksByDays", {
              countday: this.numOfDaysToDelete,
              statusTask,
            });
          })
          .then(() => {
            this.gridApi.refreshCells();
            this.buttonDisabled = true;
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else {
        this.$store.commit(
          "setError",
          this.$t("statusGrid.uncorrectNumberOfDays")
        );
      }
    },
    deleteClick() {
      let actionName = "";
      let newStatus;
      let prevStatus;
      if (this.gridType === "finished") {
        newStatus = 3;
        prevStatus = 2;
        actionName = "statusGrid.willRemove";
      } else if (this.gridType === "deleted") {
        actionName = "statusGrid.willRestore";
        prevStatus = 3;
        newStatus = 2;
      } else {
        newStatus = 3;
        prevStatus = 1;
        actionName = "statusGrid.willCleanse";
      }
      // let selectedArray = this.gridApi.getSelectedRows();
      //console.log("Array is ", selectedArray);
      if (this.selectedArray.length > 1) {
        this.$confirm(
          this.$t("statusGrid.thisAction", {
            action: this.$tc(actionName, 2),
            task: this.$tc("statusGrid.thisTask", 2),
          }),
          this.$t("statusGrid.attention"),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t("statusGrid.cancellation"),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);
            let queueIdArray = [];
            this.selectedArray.forEach((node) =>
              queueIdArray.push(`${node.idQueue}`)
            );
            return this.$store.dispatch("setTaskStatusMultiple", {
              queueIdArray,
              newStatus,
              prevStatus,
            });
          })
          .then(() => {
            this.gridApi.refreshCells();
            this.buttonDisabled = true;
          })
          .then(() => {
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else {
        this.$confirm(
          this.$t("statusGrid.thisAction", {
            action: this.$tc(actionName, 1),
            task: this.$tc("statusGrid.thisTask", 1),
          }),
          this.$t("statusGrid.attention"),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t("statusGrid.cancellation"),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);
            return this.$store.dispatch("setTaskStatus", {
              newStatus,
              prevStatus,
              queueId: this.queueId,
            });
          })
          .then(() => {
            this.gridApi.refreshCells();
            this.buttonDisabled = true;
          })
          .then(() => {
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      }
    },
    deleteAllClick(action) {
      let deleteAllWarning;
      let queueIdArray = null;
      if (action === "all") {
        deleteAllWarning = this.$t(
          "statusGrid.thisActionCleanseAllRemovedTasks"
        );
      } else if (action === "selected" && this.selectedArray.length > 1) {
        deleteAllWarning = this.$tc(
          "statusGrid.thisActionCleanseSelectedRemovedTasks",
          2
        );
        queueIdArray = [];
        this.selectedArray.forEach((node) =>
          queueIdArray.push(`${node.idQueue}`)
        );
      } else if (action === "selected" && this.selectedArray.length === 1) {
        deleteAllWarning = this.$tc(
          "statusGrid.thisActionCleanseSelectedRemovedTasks",
          1
        );
        queueIdArray = [];
        this.selectedArray.forEach((node) =>
          queueIdArray.push(`${node.idQueue}`)
        );
      }
      this.$confirm(deleteAllWarning, this.$t("statusGrid.attention"), {
        confirmButtonText: "OK",
        cancelButtonText: this.$t("statusGrid.cancellation"),
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("cleanupTrash", {
            mode: action,
            idArray: queueIdArray,
          });
        })
        .then(() => {
          this.gridApi.refreshCells();
          this.buttonDisabled = true;
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    optimalViewBtn() {
      this.gridApi.sizeColumnsToFit();
      this.settings.grids.packs.viewFull = false;
    },
    fullViewBtn() {
      let allColumnIds = [];
      this.columnApi
        .getAllColumns()
        .forEach((column) => allColumnIds.push(column.colId));
      this.columnApi.autoSizeColumns(allColumnIds);
      this.settings.grids.packs.viewFull = true;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.setEnableCellTextSelection(true);
    },
    onGridDataChanged() {
      if (this.firstRenderFlag) this.$store.commit("setLoading", false);
    },
    onGridSizeChanged(params) {
      params.api.sizeColumnsToFit();
      // this.autoSizeAll();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onGridFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.$store.commit("setLoading", false);
      this.firstRenderFlag = true;
    },
    onRowSelected(params) {
      //console.log(params);
      if (params.node.selected) {
        this.currentRowSelected = params.node.data; // текущая выбранная строка грида запоминается в буфере
        this.queueId = parseInt(this.currentRowSelected.idQueue);
        // console.log("CURRENT ROW: ", this.currentRowSelected);
        this.buttonDisabled = false;
      }
      if (this.gridApi) {
        this.selectedArray = this.gridApi.getSelectedRows();
      }
    },
    refreshClick() {
      this.$emit("refresh");
    },
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.columnDefs = [
      {
        headerName: i18n.t("tableHeaders.statusTask.id"),
        field: "idQueue",
        width: 80,
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
        cellStyle: (params) => {
          // if (!params.data.qResultLog) return { backgroundColor: "#f7f4e4" };
          if (!params.data.qResultLog) return null;
          if (params.data.qResultLog.trim().toLowerCase() === "ok")
            return { color: "darkgreen" };
          // if (params.data.qResultLog.trim().toLowerCase() === "error")
          //   return { backgroundColor: "#f7e7e4" };

          return null;
        },
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.pidTask"),
        field: "pidTask",
        width: 100,
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.nameTask"),
        field: "nameTask",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.paramsTask"),
        field: "paramsTask",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.nameServer"),
        field: "nameServer",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.qDateBegin"),
        field: "qDateBegin",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.qDateEnd"),
        field: "qDateEnd",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.nameUser"),
        field: "nameUser",
      },
      {
        headerName: i18n.t("tableHeaders.statusTask.comment"),
        field: "commentTask",
      },
      {
        headerName: "result",
        field: "qResultLog",
        width: 90,
        valueGetter: (params) => {
          if (!params.data.qResultLog) return "null";
          if (params.data.qResultLog.trim().toLowerCase()==="warning") return "warn.";
          return params.data.qResultLog.trim().toLowerCase();
        },
        cellStyle: (params) => {
          // if (!params.data.qResultLog) return { backgroundColor: "#f7f4e4" };
          if (!params.data.qResultLog) return null;
          if (params.data.qResultLog.trim().toLowerCase() === "ok")
            return { color: "darkgreen" };
          // if (params.data.qResultLog.trim().toLowerCase() === "error")
          //   return { backgroundColor: "#f7e7e4" };

          return null;
        },
      },
    ];
    (this.rowClassRules = {
      "ag-status-error": (params) =>
        params.data.qResultLog
          ? params.data.qResultLog.trim().toLowerCase() === "error"
          : false,
      "ag-status-ok": (params) =>
        params.data.qResultLog
          ? params.data.qResultLog.trim().toLowerCase() === "ok"
          : false,
      "ag-status-null": (params) =>
        !params.data.qResultLog ||
        (params.data.qResultLog.trim().toLowerCase() !== "error" &&
          params.data.qResultLog.trim().toLowerCase() !== "ok"),
    }),
      (this.defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: true,
      });
    this.settings = {
      grids: {
        packs: {
          viewFull: false,
        },
      },
    };
  },
  //grid type -- deleted/finished/running (to allow multiple selection in finished)
  props: ["gridData", "gridType"],
  components: {
    AgGridVue,
    ResultLogButton,
    FilesSelect,
  },
  computed: {
    ...mapGetters(["getRTRetFile", "getUser"]),
  },
  mixins: [parseZombiesMixin],
};
</script>

<style scoped>
.el-input-number {
  margin-top: 10px;
  margin-left: 10px;
  width: 100px;
}
.button-confirm {
  transform: scale(0.9);
}
.refresh-button {
  margin-top: 3px;
}
</style>